import {AppStateService} from "../services/appStateService";

export class ErrorReportingService {
    private appStateService: AppStateService;

    constructor() {
        this.appStateService = new AppStateService();
    }

    display(errorMessage) {
        if (this.appStateService.getAppSettingsStore().debug) {
            console.error(errorMessage);

            return true;
        }
        return false;
    }
}
